import React, { Component } from 'react';
import { connect } from 'react-redux';
import { projectCategories } from '../../utilities';
import Projectblock from '../projectblock/projectblock';
import { featuredImageWithFallback, hasCategory } from '../../utilities';
import get from 'lodash.get';
import has from 'lodash.has';

import './projectlist.css';

class Projectlist extends Component {

    render() {

        return (
            <div className="projectlist">
                {

                    this.props.projects.filter((element) => {
                       if (has(this, 'props.filter') && this.props.filter) {
                           return hasCategory(element, this.props.filter);
                       } else {
                           return true;
                       }
                    }).map((project, index) => {

                        const projectCategoriesText = projectCategories(project);
                        let projectImage = featuredImageWithFallback(project, 'large');

                        return ( <Projectblock key={project.id} id={project.id} slug={project.slug} title={project.title.rendered} projectCategories={projectCategoriesText} image={projectImage}/> )

                    }, this.props)
                }
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    let projects = [];

    if (state.projects && state.projects.projects) {
        projects = state.projects.projects;
    }

    const filter = get(state, 'projects.filter');

    return {
        projects: projects,
        filter: filter
    }
}

export default connect(mapStateToProps)(Projectlist);



// WEBPACK FOOTER //
// ./src/components/projectlist/projectlist.js